import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-badge',
  template: `
    <span
      *ngIf="total > 0"
      class="sidebar-count"
      [class.sidebar-count-highlight]="highlight"
    >
      {{ total }}
    </span>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        margin-left: 4px;
        vertical-align: middle;
      }

      .sidebar-count {
        color: #4e5f80;
        font-size: 0.7rem;
        font-weight: 600;
        line-height: 1;
      }

      .sidebar-count-highlight {
        align-items: center;
        background-color: #ff9800;
        border-radius: 999px;
        display: inline-flex;
        justify-content: center;
        min-width: 1.25rem;
        padding: 0.22rem 0.38rem;
      }
    `,
  ],
})
export class BadgeComponent implements OnInit {
  @Input() total: number;
  @Input() highlight = false;
  constructor() {}

  ngOnInit() {}
}
